import React from 'react';
import { FaTag, FaTrash, FaEye } from 'react-icons/fa';
import { formatPrice, computeUnitPriceInfo, extractManufacturer } from './pricingUtils';

const BufferPanel = ({
  show,
  onClose,
  labelBuffer,
  removeFromBuffer,
  clearBuffer,
  handleTransferBufferToPreview,
  manufacturers,
  measureUnits,
}) => {
  if (!show) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1050,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      backdropFilter: 'blur(4px)'
    }}>
      <div style={{
        backgroundColor: 'var(--card-bg)', borderRadius: '12px', width: '95%', maxWidth: '1200px',
        maxHeight: '95vh', display: 'flex', flexDirection: 'column',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
      }}>
        {/* Header */}
        <div style={{
          border: '1px solid var(--cyan)',
          color: 'var(--cyan)', padding: '1rem 1.5rem', borderRadius: '12px 12px 0 0',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center'
        }}>
          <div>
            <h5 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>
              {'🏷️'} Bufor cenówek
            </h5>
            <div style={{ fontSize: '12px', opacity: 0.9 }}>
              {labelBuffer.length} produktów w buforze
            </div>
          </div>
          <button onClick={onClose} style={{
            background: 'transparent', color: 'var(--text-secondary)',
            width: '32px', height: '32px',
            fontSize: '18px', display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}>{'×'}</button>
        </div>

        {/* Content */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '1rem' }}>
          {labelBuffer.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '3rem', color: 'var(--text-muted)' }}>
              <FaTag style={{ fontSize: '3rem', marginBottom: '1rem', opacity: 0.5 }} />
              <div style={{ fontSize: '14px', fontWeight: '500' }}>Bufor cenówek jest pusty</div>
              <div style={{ fontSize: '12px' }}>Dodaj produkty do bufora, aby zebrać cenówki przed drukowaniem</div>
            </div>
          ) : (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '0.75rem' }}>
              {labelBuffer.map((product) => {
                const displayPrice = parseFloat(product.cenowka?.cena_cenowkowa || product.cena_sprzedazy_brutto || 0);
                const { packageInfo, unitPriceText } = computeUnitPriceInfo(product, displayPrice, measureUnits);

                return (
                  <div key={product.bufferId} style={{
                    backgroundColor: 'var(--card-bg)', borderRadius: '8px', padding: '0.5rem',
                    border: '1px solid var(--border)', boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                    position: 'relative'
                  }}>
                    <button onClick={() => removeFromBuffer(product.id)} style={{
                      position: 'absolute', top: '4px', right: '4px', zIndex: 1,
                      border: '1px solid var(--danger)', color: 'var(--danger)',
                      width: '20px', height: '20px',
                      fontSize: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center'
                    }} title="Usuń z bufora">{'×'}</button>

                    {/* Cenówka 4x2cm */}
                    <div style={{
                      width: '4cm', height: '2cm', border: '1px solid var(--text)', borderRadius: '2px',
                      padding: '1.5mm', boxSizing: 'border-box', display: 'flex', flexDirection: 'column',
                      justifyContent: 'center', textAlign: 'center', backgroundColor: 'var(--card-bg)', margin: '0 auto'
                    }}>
                      <div style={{ fontSize: '19px', fontWeight: 'bold', color: 'var(--success)', lineHeight: '1', marginBottom: '1mm' }}>
                        {formatPrice(displayPrice)} zł
                      </div>
                      <div style={{ fontWeight: 'bold', fontSize: '10px', lineHeight: '1.1', marginBottom: '0.5mm', overflow: 'hidden', textOverflow: 'ellipsis', color: 'var(--text)' }}>
                        {product.finalName || product.nazwa_uproszczona || product.nazwa}
                      </div>
                      <div style={{ fontWeight: 'bold', fontSize: '8px', color: 'var(--info)', lineHeight: '1.1', marginBottom: '0.5mm' }}>
                        {/* Fallback extractManufacturer: stare pozycje bufora (sprzed zapisu
                            producenta w product_data) tez maja pokazac producenta z nazwy */}
                        {manufacturers.find(m => m.id === product.producent_id)?.nazwa
                          || product.manufacturer
                          || extractManufacturer(product.nazwa, null, manufacturers)
                          || 'Brak'}
                      </div>
                      <div style={{ fontSize: '7px', color: 'var(--text-secondary)', lineHeight: '1.1', marginTop: 'auto' }}>
                        {[packageInfo, unitPriceText].filter(Boolean).join(' | ')}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* Footer */}
        <div style={{
          padding: '0.75rem 1rem', borderTop: '1px solid var(--border)',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          backgroundColor: 'var(--bg)', borderRadius: '0 0 12px 12px'
        }}>
          <button onClick={clearBuffer} disabled={labelBuffer.length === 0} style={{
            padding: '6px 12px', fontSize: '12px',
            border: `1px solid ${labelBuffer.length === 0 ? 'var(--border)' : 'var(--danger)'}`,
            color: labelBuffer.length === 0 ? 'var(--text-muted)' : 'var(--danger)',
            opacity: labelBuffer.length === 0 ? 0.6 : 1
          }}>
            <FaTrash style={{ marginRight: '4px' }} />Wyczyść bufor
          </button>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <button onClick={onClose} style={{
              padding: '6px 12px', fontSize: '12px', border: '1px solid var(--text-muted)',
              color: 'var(--text-muted)'
            }}>Zamknij</button>
            <button onClick={handleTransferBufferToPreview} disabled={labelBuffer.length === 0} style={{
              padding: '6px 12px', fontSize: '12px',
              border: `1px solid ${labelBuffer.length === 0 ? 'var(--border)' : 'var(--cyan)'}`,
              color: labelBuffer.length === 0 ? 'var(--text-muted)' : 'var(--cyan)',
              opacity: labelBuffer.length === 0 ? 0.6 : 1
            }}>
              <FaEye style={{ marginRight: '4px' }} />Przenieś do podglądu ({labelBuffer.length})
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BufferPanel;
